import { render, staticRenderFns } from "./ClientAccess.vue?vue&type=template&id=67385df0&scoped=true"
import script from "./ClientAccess.vue?vue&type=script&lang=js"
export * from "./ClientAccess.vue?vue&type=script&lang=js"
import style0 from "./ClientAccess.vue?vue&type=style&index=0&id=67385df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67385df0",
  null
  
)

export default component.exports